export default __webpack_public_path__ + "static/media/DejaVuSerif.69fa14d2.ttf";